import React from 'react';

import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Posts from 'components/Posts';

const recipesPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="recipes" />
      <Posts />
    </Layout>
  );
};

export default recipesPage;
